import React from 'react'

import './skill.css'

function Skills() {
    return (
        <div className="skill">
        <h1>Personal Skills</h1>
        <div className="skill-c">
        <div className="skill-c-left">
        <p>Passionate Web developer who wants to explore technology stack</p>
        <p>Constantly learning and improving. In a fast moving industry 
        like ours, staying on top of your game means you never stop learning.</p>
        <p>Keeping up to date with the industry. 
        Being able to manage time and prioritize. .</p>
        <p>Good communication skills, team buiding</p>
        
        </div>
        <div className="skill-card">
        <img src="timages/tech.png" alt="" className="skill-card-img"></img>
        
        </div>
      
     
      
      
 
        
      
        
        </div>

   
            
        </div>
    )
}

export default Skills
